<template>
    <div>
      <img :src="selectedInstrument" width="36rem" @click="selectInstrument" style="cursor:pointer"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Instruments',
  props: {
  },
  data () {
    return {
      selectedInstrument: 'xylophone.png'
    }
  },
  methods: {
    ...mapActions([
      'changeInstrument'
    ]),
    ...mapState(['howlSound']),
    selectInstrument () {
      const payLoad = {}

      if (this.selectedInstrument === 'xylophone.png') {
        this.selectedInstrument = 'trumpet.png'
        payLoad.instrument = 'trumpet.mp3'
      } else if (this.selectedInstrument === 'trumpet.png') {
        this.selectedInstrument = 'piano.png'
        payLoad.instrument = 'piano.mp3'
      } else if (this.selectedInstrument === 'piano.png') {
        this.selectedInstrument = 'xylophone.png'
        payLoad.instrument = 'xylophone.mp3'
      }
      this.changeInstrument(payLoad)
    }
  }
}
</script>

<style scoped>

</style>
